import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { RouterModule } from '@angular/router';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { CustomerCatComponent } from '../customer-cat/customer-cat.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-customer-cat-list',
  templateUrl: './customer-cat-list.component.html',
  styleUrls: ['./customer-cat-list.component.css']
})
export class CustomerCatListComponent implements OnInit {

  public menu_item_id = '30';
  public add_auth;
  public edit_auth;
  public del_auth;

  private dp = [];
  displayedColumns = ['customer_category_name', 'customer_category_name_en', 'edit', 'del'];
  dataSource = new MatTableDataSource(this.dp);
  addDialogRef: MatDialogRef<CustomerCatComponent>;
  @ViewChild(MatSort) sort: MatSort;

  model = { 'table_name': 'customer_category', 'customer_category_name': '', 'customer_category_name_en': '' };

  Success_Msg; Error_Msg; Del_Msg;

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, public dialog: MatDialog, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);


    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Del_Msg').subscribe((res: string) => {
      this.Del_Msg = res;
    });

  }


  ngOnInit() {
    this.add_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.ADD_AUTH);
    this.edit_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.EDIT_AUTH);
    this.del_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.DELETE_AUTH);
  }

  search() {
    let condition = "";

    if (this.model['customer_category_name'] != '')
      condition = " (`customer_category_name` LIKE '%" + this.model['customer_category_name'] +
        "%' OR `customer_category_name_en` LIKE '%" + this.model['customer_category_name'] + "%') AND ";

    let query = "SELECT * FROM `customer_category` WHERE" + condition + " `status` = '1'";
    let obj = { cmd: 'getList', query: query };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.dp = data.data['list'];
        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
      });
  }

  newCustCatEntry() {
    this.addDialogRef = this.dialog.open(CustomerCatComponent, {
      hasBackdrop: false,
      //data: this.dialog_data
    });
    this.addDialogRef
      .afterClosed()
      .subscribe(result => {
        if (result != null && result['op_type'] == 'success')
          this.search();
        //console.log(this.acct_income);
      });
  }
  editCustCat(row) {
    let dialog_data = {
      'table_name': 'customer_category', 'customer_category_id': row.customer_category_id,
      'customer_category_name': row.customer_category_name,
      'customer_category_name_en': row.customer_category_name_en, 'comment': row.comment
    };
    this.addDialogRef = this.dialog.open(CustomerCatComponent, {
      hasBackdrop: false,
      data: dialog_data
    });
    this.addDialogRef
      .afterClosed()
      .subscribe(result => {
        if (result != null && result['op_type'] == 'success')
          this.search();
      });
  }

  delCustCat(row) {
    if (confirm(this.Del_Msg)) {
      let values = [{ 'table_name': this.model['table_name'], 'customer_category_id': row.customer_category_id }];
      let obj = { cmd: 'deleteRec', values: values };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          //console.log(data);
          this.applicationConstants.appComp.hideBusyCursor();
          if (data.status['type'] == 'success') {
            alert(this.Success_Msg);
            this.search();
          }
          else {
            alert(this.Error_Msg);
          }
        });
    }
  }
}
